export const FETCH_FILTER_VALUE = 'FETCH_FILTER_VALUE';
export const FETCH_FILTER_VALUE_SUCCESS = 'FETCH_FILTER_VALUE_SUCCESS';
export const FETCH_FILTER_VALUE_FAILURE = 'FETCH_FILTER_VALUE_FAILURE';
export const FETCH_RANGES_VALUE = 'FETCH_RANGES_VALUE';
export const FETCH_RANGES_VALUE_SUCCESS = 'FETCH_RANGES_VALUE_SUCCESS';
export const FETCH_RANGES_VALUE_FAILURE = 'FETCH_RANGES_VALUE_FAILURE';
